import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Header({ onToggleSidebar, sidebarOpen = false }) {
  const { email, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const displayName = email ? email.split('@')[0] : 'Admin';
  const initials = displayName.slice(0, 2).toUpperCase();

  return (
    <header className="admin-header">
      <button
        type="button"
        className="sidebar-toggle"
        aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={sidebarOpen}
        onClick={onToggleSidebar}
      >
        {sidebarOpen ? '✕' : '☰'}
      </button>
      <div className="header-brand-mobile">RealAyurveda Admin</div>
      <div className="header-actions">
        <a
          href="https://realhealthcareayurveda.com"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-ghost btn-sm header-store-link"
        >
          <span className="header-store-text">View Store</span>
          <span className="header-store-icon" aria-hidden="true">↗</span>
        </a>
        <div className="header-user">
          <div className="user-avatar">{initials}</div>
          <div className="user-info">
            <span className="user-name">{displayName}</span>
            <span className="user-email">{email || 'admin@RealAyurveda.com'}</span>
          </div>
        </div>
        <button type="button" className="btn btn-ghost btn-sm header-logout" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </header>
  );
}
